//
// NEO SEGMENT JS
//
// Neo Hide and Show => Button active hides all other button and Modals
// BS4 Modal--topic => Handles Modal Window for this very case
//

// Hide and Show Neo stuff
function openNeo(e){
  hideContents();
  hideButtons();
  displayContent(e);
}

function closeNeo(){
  hideContents();
  displayButtons();
}

function displayContent(e){
  document.querySelector('[data-neo-card=' + e + ']').style.display = 'block';
  document.querySelector('[data-neo-card=' + e + ']').closest('li').style.display = 'block';
}
function hideContents(){
  document.querySelectorAll('[data-neo-li]').forEach(function(e){
    e.style.display = 'none';
    e.querySelector('[data-neo-card]').style.display = 'none';
  });
}
function displayButtons(){
  document.querySelectorAll('[data-neo-button]').forEach(function(e){
    e.style.display = 'block';
    e.closest('li').style.display = 'block';
    e.closest('li').style.flex = '';
    e.closest('li').style.maxWidth = '';
  });
}
function hideButtons(){
  document.querySelectorAll('[data-neo-button]').forEach(function(e){
    e.style.display = 'none';
    e.closest('li').style.flex = '0 0 100%';
    e.closest('li').style.maxWidth = 'none';
  });
}
// At click => reset :
const container = document.querySelector('[data-neo-container]');
if(container !== null){
  document.addEventListener('click', event => {
    if (!container.contains(event.target)) {
      closeNeo();
    }
  });
}
else{
  // console.log("Element DOES NOT exist! container => Nothing");
}

// BT3 NEO MODAL (modal--topic)
var fn_modal_topic_bs = function () {
  // > body scrolling enabled + click enabled on backdrop
  $('.modal--topic').on('show.bs.modal', function () {
    $("body").addClass("modal-open--topic");

  }).on('shown.bs.modal', function () {
    $("body").addClass("modal-open--topic");
    $(".modal-backdrop").on('click', function (e) {

      // >> closing the modal on clicking on backdrop
      $('.modal--topic').modal('hide');
    });
  }).on('hidden.bs.modal', function (e) {
    // >> hiding content and showing back buttons on clicking on backdrop
    $(".modal-backdrop").off('click').remove();
    $("body").removeClass("modal-open--topic");
    // >> Close Neo fn
    closeNeo();
  });

};
